import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ethers } from 'ethers'
import { CHALLENGE_ABI } from '../abis/ChallengeABI'

function parseJoinError(err: unknown): string {
  if (err instanceof Error) {
    const msg = err.message
    if (msg.includes('user rejected') || msg.includes('ACTION_REJECTED'))
      return '트랜잭션을 거부했습니다'
    if (msg.includes('insufficient funds')) return '잔액이 부족합니다'
    if (msg.includes('already joined')) return '이미 참가한 챌린지입니다'
    if (msg.includes('max participants')) return '최대 인원에 도달했습니다'
    return msg.slice(0, 100)
  }
  return '트랜잭션에 실패했습니다'
}

export function useJoin(challengeAddress: string, entryFee: bigint) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      if (!window.ethereum) throw new Error('MetaMask가 설치되어 있지 않습니다')
      const browserProvider = new ethers.BrowserProvider(window.ethereum)
      const signer = await browserProvider.getSigner()
      const contract = new ethers.Contract(challengeAddress, CHALLENGE_ABI, signer)
      const tx = await (
        contract.join as (opts: { value: bigint }) => Promise<ethers.TransactionResponse>
      )({
        value: entryFee,
      })
      await tx.wait()
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['challenge-detail', challengeAddress] })
      void queryClient.invalidateQueries({ queryKey: ['challenges'] })
    },
    meta: { parseError: parseJoinError },
  })
}

export { parseJoinError }
